import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { DialogModal } from '../DialogModal'
import { ReactComponent as IconInfo } from '../../assets/icons/IconInfo.svg'
import { useCustomTooltipStyles } from '../../stylesheets/customMaterialUIstyles'
import PrintIcon from '@material-ui/icons/Print'
import Tooltip from '@material-ui/core/Tooltip'


const PrinterSetInfo = ({ event }) => {
  const [showLockPrinterDialog, setShowLockPrinterDialog] = useState(false)
  const customTooltipClasses = useCustomTooltipStyles()

  const modalBody = (
    <div className='printer-config'>
      <PrintIcon />
      <span>{event.printGroupDisplayName || 'None'}</span>
    </div>
  )

  if (!event.printGroupDisplayName) return null

  return (
    <>
      <div className='printer-info' onClick={setShowLockPrinterDialog}>
        <Tooltip
          arrow
          classes={customTooltipClasses}
          placement="bottom-start"
          title="Printer set information"
        >
          <IconInfo />
        </Tooltip>
      </div>
      <DialogModal
        closeModalCallback={setShowLockPrinterDialog}
        isCancelButton={false}
        modalBody={modalBody}
        modalIsOpen={showLockPrinterDialog}
      />
    </>
  )
}

PrinterSetInfo.defaultProps = {
  event: {},
}

PrinterSetInfo.propTypes = {
  event: PropTypes.object,
}

export default PrinterSetInfo
